import EA from 'helpers/init';

export default EA.Methods.copyUrl = ($this) => {
    const copyUrl = $this;

    copyUrl.addEventListener('click', (e) => {
        const url = window.location.href;
        e.preventDefault();
        navigator.clipboard.writeText(url);
    });
};
